<template>
    <div class='tag-wrapper primary-bd-ee' 
        v-if = 'false'
        v-show='propsData.tagInfo.length > 0'
    >
        <div class='item card-bg-f5 sub-text-26' v-for='item in propsData.tagInfo' @click='selectItem(item)' :key='item.name'>
            <!-- :class='{"active": activeName == item.name}' -->
            {{item.name}}
        </div>
    </div>
</template>

<script>
// import { initData } from "@/components/mixins"

export default {
    name: 'tagInfo',
    data() {
        return {
            activeName: -1
        }
    },
    props: {
        propsData: {
            type: Object,
            default() {
                return {
                    tagInfo: [
                        {
                            name: '标签1'
                        },
                        {
                            name: '标签2'
                        },
                        {
                            name: '标签3'
                        },
                        {
                            name: '标签4'
                        }
                    ],
                }
            }
        }
    },
    inject: ['pageDetail'],
    computed: {
    },
    beforeCreate: function () {
    },
    created: function () {
    },
    mounted: function () {
    },
    methods: {
        selectItem(item) {
            // this.activeName = item.name;
            // console.log('当前标签', this.activeName)
            // this.$sendStat(this.stats('tagclick'))
            // this.$sendStat(`pc_newschrome_${window.statSeq}.tags.click`);
            // this.$client.openBrowserDlgNewUrl({ url: `http://news.10jqka.com.cn/pclient/zxNewList.html?type=tags&tagname=${item.name}&treeid=${item.id}`, name: item.name + '资讯' })
            //this.$dispatch('basic','LISTEN_CHILD', {
            //method: 'openTab',
            //data:{
            //		type: 'tags',
            //		tag: item.name,
            //		stockCode: ''
            //	}
            //})
        },
    }
}
</script>

<style lang="less" scoped>
@import '../../common/style/index.less';
.tag-wrapper {
    padding: 20px 0 20px 0;
    border-bottom-width: 1px;
    border-bottom-style: solid;
    display: flex;
    flex-wrap: wrap;
    .item {
        // cursor: pointer;
        margin-top: 12px;
        height: 30px;
        padding: 5px 12px 5px 12px;
        box-sizing: border-box;
        font-size: 14px;
        border-radius: 15px;
        display: flex;
        align-items: center;
        margin-right: 20px;
    }
    .active {
        background: #ddd;
        // color: #eee !important;
    }
}
.night {
    .active {
        background: #3e4346 !important;
        color: #eee !important;
    }
}
</style>
